import { EmpPosition } from '~/data/employee';
import { EmploymentPositionProposalProps } from '~/data/proposals';
import { scheduledDateFormats } from '~/features/ScheduledEmploymentChanges/helpers';
import { mapSubmitDataUtils } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/Common';

export const empPositionNewTypeToLegacy = (
  data: EmploymentPositionProposalProps,
): EmpPosition => {
  const { submissionDateInFormat } = mapSubmitDataUtils({
    defaultSubmissionDateFormat: scheduledDateFormats.dashFormat,
  });
  const {
    proposalData: { ip, up, cc },
  } = data;
  return {
    fEmpCostCenters: cc.map((c) => {
      return {
        fEmpCostCenter: c.costCenterFK,
        fEmpCostCenterPercent: c.allocationPercent || 0,
        fEmpCostCenterIsDefault: c.isDefault,
        fEmpId: c.id,
        fEmpCostCenterCustomData: c.customData,
      };
    }),
    fEmpJobTitle: ip.jobTitle || '',
    fEmpLegalEntity: ip.legalEntity,
    fEmpUnitPositions: up.map((untiPos) => {
      return {
        fEmpUnitPos: untiPos.unitPositionFK,
        fEmpUnitPosPercent: untiPos.allocationPercent || 0,
        fEmpId: untiPos.id,
      };
    }),
    fInternalPositionEmpId: ip.employeeFK,
    fInternalPositionInfo: ip.info || '',
    fInternalPositionManager: ip.managerFK,
    fInternalPositionPosition: ip.positionFK,
    fInternalPositionStartDate: submissionDateInFormat(ip.startDate),
    fInternalPositionUnit: ip.unitFK,

    //not used just needed for type
    fInternalPositionAttachmentId: -1,
    fInternalPositionAttachmentName: '',
    fInternalPositionEnteredTime: '',
    fInternalPositionId: -1,
    fInternalPositionIncludeInOverallExperience: false,
    fInternalPositionIsCurrent: true,
    fInternalPositionIsPending: false,
  };
};
